import { Consultation } from "@/app/_components/consultation-card";

export const SearchLink = ({
  url,
  label,
  icon,
}: {
  url: string;
  label: string;
  icon?: string;
}) => (
  <Consultation.SearchButton asChild>
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="!w-auto flex items-center text-wrap"
    >
      {icon ? <img src={icon} alt={label} className="w-4 h-4 mr-2" /> : null}
      {label}
      <Consultation.OutSideLinkIcon />
    </a>
  </Consultation.SearchButton>
);
